import queryString from 'query-string'

export const returnType = {
  default: 'default',
  lifetime: 'lifetime',
  return: 'return',
}

export const returnTypeParam = {
  lifetime: 'lifetime',
  return: 'return',
}

export const getButtonType = () => {
  let type = returnType.default
  const parsed = queryString.parse(__BROWSER__ ? window.location.search : '')
  const parseType = parsed?.returnType
  type = returnType[`${parseType}`] || type
  return type
}

export const setUrlReturnTypeParam = type => {
  const param = returnTypeParam[`${type}`]
  return param ? `returnType=${param}` : ''
}
